// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-table-header {
  display: grid;
  grid-template-columns: 3fr 1.5fr 1.5fr 1fr 2fr;
  column-gap: 1rem;
  text-align: start;
  padding: 1rem 2rem;
  font-weight: bold;
}

.channel-list__name {
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently not supported by any browser */
}

.channel-list__buttons-cell {
  width: 5%;
}

.channel-list__enabled-cell {
  width: 10rem;
}

.channel-list {
  height: calc(100% - 6rem);
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: relative;
}

.channel-list-table {
  min-width: 122rem;
  margin: 0 1rem;
}

.channel-list__btn-create-operator {
  float: left;
  margin: 1.5rem 4rem;
}

.channel-list__btn-cancel-create-operator {
  background-color: #d22e37;
  float: left;
  margin: 1.5rem 4rem;
  margin-left: -2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/channel/channel-main/channel-list/ChannelList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,wBAAwB;EACnD,wBAAwB,EAAE,cAAc;EACxC,sBAAsB,EAAE,YAAY;EACpC,qBAAqB,EAAE,2BAA2B;EAClD,iBAAiB,EAAE,iEAAiE;AACtF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".channel-table-header {\r\n  display: grid;\r\n  grid-template-columns: 3fr 1.5fr 1.5fr 1fr 2fr;\r\n  column-gap: 1rem;\r\n  text-align: start;\r\n  padding: 1rem 2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.channel-list__name {\r\n  cursor: pointer;\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none; /* Konqueror */\r\n  -moz-user-select: none; /* Firefox */\r\n  -ms-user-select: none; /* Internet Explorer/Edge */\r\n  user-select: none; /* Non-prefixed version, currently not supported by any browser */\r\n}\r\n\r\n.channel-list__buttons-cell {\r\n  width: 5%;\r\n}\r\n\r\n.channel-list__enabled-cell {\r\n  width: 10rem;\r\n}\r\n\r\n.channel-list {\r\n  height: calc(100% - 6rem);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n  position: relative;\r\n}\r\n\r\n.channel-list-table {\r\n  min-width: 122rem;\r\n  margin: 0 1rem;\r\n}\r\n\r\n.channel-list__btn-create-operator {\r\n  float: left;\r\n  margin: 1.5rem 4rem;\r\n}\r\n\r\n.channel-list__btn-cancel-create-operator {\r\n  background-color: #d22e37;\r\n  float: left;\r\n  margin: 1.5rem 4rem;\r\n  margin-left: -2rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
